var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _path14, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApacheJmeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 84.8",
    style: {
      enableBackground: "new 0 0 250 84.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#path3212_00000104680582160048807230000000615615976103098244_);}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#BE202E;}\r\n\t.st3{opacity:0.35;fill:#BE202E;enable-background:new    ;}\r\n\t.st4{fill:url(#path3239_00000028301384904509279140000011208834398517801606_);}\r\n\t.st5{fill:url(#path3250_00000068649875119988048030000011955016710932444598_);}\r\n\t.st6{fill:url(#path3261_00000096739155863950583880000018046378613037769612_);}\r\n\t.st7{fill:url(#path3272_00000121254101199083673540000010334643414549554831_);}\r\n\t.st8{fill:url(#path3283_00000144305221216707533130000013689714586252592030_);}\r\n\t.st9{fill:url(#path3294_00000155135297772043110570000012897939758330073479_);}\r\n\t.st10{fill:url(#path3309_00000118379619428020112690000001080160172304849073_);}\r\n\t.st11{fill:url(#path3324_00000016034025379003532490000000754442886256638107_);}\r\n\t.st12{fill:#B0AFB0;}\r\n\t.st13{fill:url(#path3718_00000052810052211714506560000007008683870349991563_);stroke:#D22128;}\r\n\t.st14{fill:#D22128;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "test-automation-tools") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3203"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3212_00000183231459999769627480000002934112799837237155_",
    gradientUnits: "userSpaceOnUse",
    x1: -9430.6602,
    y1: 519.4962,
    x2: -9400.9619,
    y2: 554.2219,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3212",
    style: {
      fill: "url(#path3212_00000183231459999769627480000002934112799837237155_)"
    },
    d: "M36,0.4 c-1.3,0.8-3.5,3-6.2,6.2l2.4,4.6c1.6-2.4,3.4-4.6,5.4-6.7c-1.9,2.1-3.6,4.4-5.1,6.8c3.2-0.2,6.3-0.6,9.4-1.2 C43.1,4,40.5-1.1,36,0.4z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3214",
    className: "st1",
    d: "M31.9,26.5C31.9,26.5,32,26.5,31.9,26.5c0,0-0.3,0-0.4,0H31.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path3216",
    className: "st1",
    d: "M29.5,34.7c-0.2,0.1-0.4,0.1-0.6,0.1C29.1,34.7,29.3,34.7,29.5,34.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path3218",
    className: "st1",
    d: "M12.7,53c3.3-8.7,6.8-17.4,11-25.7h-0.3l-0.2-0.5c-4.8,9.7-9,19.7-12.8,29.9l0.4,0.7H11 c0,0,0-0.1,0-0.1C11.6,55.9,12.1,54.4,12.7,53z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3222",
    className: "st2",
    d: "M27.9,38.8c-0.3,0.1-0.6,0.1-0.9,0.2l0,0C27.3,38.9,27.6,38.9,27.9,38.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path3224",
    className: "st3",
    d: "M27.9,38.8c-0.3,0.1-0.6,0.1-0.9,0.2l0,0C27.3,38.9,27.6,38.9,27.9,38.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path3226",
    className: "st2",
    d: "M28.7,34.8L28.7,34.8c0.3,0,0.5,0,0.7-0.1L28.7,34.8L28.7,34.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path3228",
    className: "st3",
    d: "M28.7,34.8L28.7,34.8c0.3,0,0.5,0,0.7-0.1L28.7,34.8L28.7,34.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3239_00000156588036011342620790000013580510885248605090_",
    gradientUnits: "userSpaceOnUse",
    x1: -9581.7578,
    y1: 491.1046,
    x2: -9369.5264,
    y2: 491.1046,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3239",
    style: {
      fill: "url(#path3239_00000156588036011342620790000013580510885248605090_)"
    },
    d: "M25.1,23 c2.2-4.1,4.5-8.1,7.1-11.8l-2.4-4.6c-3.6,4.4-6.9,9.2-9.9,14.1l3.1,6.2C23.8,25.6,24.5,24.3,25.1,23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3250_00000158746714747777317540000000599187819081105069_",
    gradientUnits: "userSpaceOnUse",
    x1: -9556.1328,
    y1: 513.1505,
    x2: -9429.666,
    y2: 513.1505,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#CD2032"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3250",
    style: {
      fill: "url(#path3250_00000158746714747777317540000000599187819081105069_)"
    },
    d: "M10.8,58.1 c-0.4,1.1-0.9,2.3-1.2,3.5c-0.4,1.3-0.6,1.7-1.3,3.7c1.1,0.7,1.9,1.7,2.4,2.8c-0.1-1.3-0.7-2.6-1.6-3.5c5,0.2,9.2-1.2,11.1-5.3 c-0.9,1.2-2.1,1.7-4.2,1.5l0,0c4-1.8,5.5-3.6,7.2-6.8c-3,3.8-7.8,3-12,3.3L10.8,58.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3261_00000059280215583557525480000002283942555169948595_",
    gradientUnits: "userSpaceOnUse",
    x1: -9569.8369,
    y1: 489.5583,
    x2: -9357.6055,
    y2: 489.5583,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3261",
    style: {
      fill: "url(#path3261_00000059280215583557525480000002283942555169948595_)"
    },
    d: "M12,52.4 c3.4-8.6,7-17.2,11.1-25.5L20,20.7C14.3,29.9,9.3,39.9,7.2,50.5l3.2,6.2C10.9,55.3,11.4,53.9,12,52.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3272_00000031898337952562943490000008861347566293814421_",
    gradientUnits: "userSpaceOnUse",
    x1: -9554.3516,
    y1: 492.4829,
    x2: -9442.8184,
    y2: 492.4829,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#CD2032"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3272",
    style: {
      fill: "url(#path3272_00000031898337952562943490000008861347566293814421_)"
    },
    d: "M7.1,50.7 c-0.4,2.1-0.7,4.1-0.9,6.2c-1-1.6-3.6-3.2-3.6-3.2c1.9,2.8,3.3,5.5,3.5,8.2c-1.4,0.1-2.7-0.1-4-0.7c1,1,2.1,1.7,3.4,2.1 c-1.5,0.1-3.1,1.2-4.8,2.4c2.4-1,4.3-1.3,5.6-1C4.3,70.8,2.2,77.6,0,84.8c2.1-0.5,6.3-18.8,10.3-28l0,0l-3.2-6.2 C7.2,50.6,7.1,50.6,7.1,50.7L7.1,50.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3283_00000178918349627828359340000009621015618019070655_",
    gradientUnits: "userSpaceOnUse",
    x1: -9569.8369,
    y1: 511.5831,
    x2: -9357.6055,
    y2: 511.5831,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3283",
    style: {
      fill: "url(#path3283_00000178918349627828359340000009621015618019070655_)"
    },
    d: "M23.6,27.5 c-4.8,9.7-8.9,19.8-12.5,30l2.6-0.3h-0.2c9-1.3,14.5-11,16.8-19.2c-1,0.6-2.2,0.9-3.4,1l0,0c2.7-1.1,4.8-3.2,5.9-5.8 c-1.3,0.8-2.7,1.5-4.2,1.6l0,0c4.2-1.4,6.3-5.8,7.2-9.8l0,0c-1.1,0.8-2.5,1.2-3.8,1.4l2.3-0.2L32,26.4c-0.1,0-0.3,0-0.4,0.1h0.1 l-8,0.9C23.6,27.4,23.6,27.4,23.6,27.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3294_00000143614929177945475880000001614199366182397844_",
    gradientUnits: "userSpaceOnUse",
    x1: -9582.9971,
    y1: 510.3783,
    x2: -9370.7666,
    y2: 510.3783,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3294",
    style: {
      fill: "url(#path3294_00000143614929177945475880000001614199366182397844_)"
    },
    d: "M32.6,11.3 c-3.3,5-6.2,10.5-9,16.1l8-0.9c6-2.9,8.6-10.4,10.4-16.4C38.9,10.7,35.8,11.1,32.6,11.3L32.6,11.3z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path3296",
    className: "st2",
    d: "M27.4,38.9L26.9,39l0,0C27.1,38.9,27.3,38.9,27.4,38.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path3298",
    className: "st3",
    d: "M27.4,38.9L26.9,39l0,0C27.1,38.9,27.3,38.9,27.4,38.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3309_00000082349425838083191440000002841405564287404199_",
    gradientUnits: "userSpaceOnUse",
    x1: -9569.8369,
    y1: 518.2209,
    x2: -9357.6055,
    y2: 518.2209,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3309",
    style: {
      fill: "url(#path3309_00000082349425838083191440000002841405564287404199_)"
    },
    d: "M27.4,38.9L26.9,39l0,0 C27.1,38.9,27.3,38.9,27.4,38.9z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path3311",
    className: "st2",
    d: "M28.7,34.8h0.2H28.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path3313",
    className: "st3",
    d: "M28.7,34.8h0.2H28.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3324_00000054953270980929138660000004326844704525324428_",
    gradientUnits: "userSpaceOnUse",
    x1: -9569.8369,
    y1: 517.3828,
    x2: -9357.6055,
    y2: 517.3828,
    gradientTransform: "matrix(0.17 -0.36 0.36 0.17 1460.5338 -3479.5361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3324",
    style: {
      fill: "url(#path3324_00000054953270980929138660000004326844704525324428_)"
    },
    d: "M28.7,34.8h0.2H28.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3343",
    className: "st12",
    d: "M32.4,26.4v1.2h-0.3v-1.2h-0.4v-0.3h1.1v0.3H32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3345",
    className: "st12",
    d: "M34.3,26.6l-0.4,0.8h-0.2l-0.3-0.8v0.9h-0.3v-1.4h0.4l0.4,0.8l0.4-0.8h0.4v1.4h-0.3L34.3,26.6 L34.3,26.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3718_00000124842360440367377890000005901620584750478465_",
    gradientUnits: "userSpaceOnUse",
    x1: -5535.417,
    y1: -478.7324,
    x2: -5514.0366,
    y2: -478.7324,
    gradientTransform: "matrix(0.42 -0.91 0.91 0.42 4132.186 -7638.7207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#E97826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3718",
    style: {
      fill: "url(#path3718_00000124842360440367377890000005901620584750478465_)",
      stroke: "#D22128"
    },
    d: " M45.5,82.5c-2,0-4.1-0.2-6.1-0.7v-8c4.9,1.5,12.4,0.8,11.8-5.9c0,0,0-43.8,0-43.8h9.6v43.5C61.5,76.3,54.1,83.2,45.5,82.5"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path3720",
    d: "M84.1,69.3l-9.9-35.4h-0.3c0.8,9.2,0.5,26,0.6,35.4H66V24.1h13l9.8,34.5h0.2l10.3-34.5h13v45.2h-8.9 c0-9.3-0.1-26.3,0.4-35.4h-0.2L92.9,69.3H84.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path3722",
    d: "M131.4,40.8c-4,0.1-5.8,3-6.1,7.2h12C137.5,44.5,135.4,40.5,131.4,40.8 M132.7,69.8 c-16.4,1.3-21.8-20.2-12.6-31.2c5.5-6,16.4-6.2,22.2-0.5c4.2,4.2,4.1,10.7,4,16.2h-21c-0.2,10.5,12.4,9.7,19,5.8v7.3 C140.6,69.3,136.7,69.8,132.7,69.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path3724",
    d: "M165.1,62.4c1.8,0,3.5-0.5,5.2-1.1v7c-21.7,8-18.1-12.6-18.2-26.5h-4.5v-4l5.2-3.2l2.7-7.3h6v7.3h8.4v7.1 h-8.4v16.6C161.3,60.5,163,62.5,165.1,62.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path3726",
    d: "M188.1,40.8c-4,0.1-5.8,3-6.1,7.2h12C194.2,44.5,192,40.5,188.1,40.8 M189.3,69.8 c-16.4,1.3-21.8-20.2-12.6-31.2c5.5-6,16.5-6.2,22.2-0.5c4.2,4.2,4.2,10.7,4,16.2h-21.1c-0.2,10.5,12.4,9.7,19,5.8v7.3 C197.3,69.3,193.4,69.8,189.3,69.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path3728",
    d: "M223.4,34.1c1,0,2,0,3,0.2v8.9C209.8,39.7,216,60,214.9,69.3h-9.4V34.7h7.1l1.4,5.2h0.5 C216.1,36.5,219.5,33.9,223.4,34.1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text3756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3109",
    d: "M235.9,34h-2.1v-8.1h-2.5v-1.7h7.1v1.7h-2.5L235.9,34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3111",
    d: "M243.9,34l-2.2-7.7l0,0c0.1,2,0.1,5.7,0.1,7.7h-1.9v-9.9h2.9l2.1,7.6l0,0l2.3-7.6h2.9V34h-2 c0-1.9-0.1-5.9,0.1-7.7H248l-2.3,7.7L243.9,34"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g8126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8130",
    className: "st14",
    d: "M51.1,17.2L57.9,1h1.3L66,17.2h-1.7l-2.1-5h-7.2l-2.1,5H51.1z M58.6,2.9l-3.3,8h6.5L58.6,2.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8132",
    className: "st14",
    d: "M67.7,17.2V1h6.7c6.1,0.1,6.3,10.1,0.1,10.2c0,0-5.2,0-5.2,0v6H67.7z M69.3,9.8 c2.9-0.1,8.6,1,8.3-3.7c0.3-4.5-5.5-3.7-8.3-3.7L69.3,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8134",
    className: "st14",
    d: "M78.3,17.2L85,1h1.3l6.8,16.1h-1.7l-2.1-5H82l-2.1,5H78.3z M85.7,2.9l-3.3,8h6.6L85.7,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8136",
    className: "st14",
    d: "M100.7,0.9c2.5-0.1,4.8,1.3,6,3.5l-1.3,0.8c-3-5.8-11.4-1.9-10.7,3.8c-0.4,6.2,8,9.5,11,3.8 l1.3,0.7C97.3,26.7,84.8,2.8,100.7,0.9L100.7,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8138",
    className: "st14",
    d: "M121.9,1v16.1h-1.6V9.6h-9.5v7.5h-1.6V1h1.6v7.2h9.5V1H121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8140",
    className: "st14",
    d: "M136.4,15.8v1.4h-10.8V1h10.6v1.4h-9.1v5.8h7.9v1.3h-7.9v6.2L136.4,15.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApacheJmeter);
export default __webpack_public_path__ + "static/media/apache-jmeter.17a8b808f0aa5f488ffa4f444dee9066.svg";
export { ForwardRef as ReactComponent };